module.exports = __webpack_public_path__ + "media/images/top/common/img_step04-bd5d0bd554dd5b86d156a61c55a8558a.png";